<template>
<div class="q-pa-md q-mx-auto" style="min-width: 350px">
  <h4 class="text-center">Какое-то название</h4>
  <p>Представьтесь, пожалуйста</p>
  <q-form
    @submit.prevent="onSubmit"
    @reset="onReset"
    class="q-gutter-md"
  >
    <q-input
      filled
      v-model="data.login"
      label="Логин"
      lazy-rules
      :rules="[ val => val && val.length > 0 || 'Что-то ввести все-таки надо']"
    />

    <q-input
      filled
      :type="isPwd ? 'password' : 'text'"
      v-model="data.password"
      label="Пароль"
      lazy-rules
      :rules="[
        val => val !== null && val !== '' || 'Это тоже обязательно',
      ]"
    >
    <template v-slot:append>
        <q-icon
          :name="isPwd ? 'visibility_off' : 'visibility'"
          class="cursor-pointer"
          @click="isPwd = !isPwd"
        />
      </template>
    </q-input>

    <div>
      <q-btn
        size="sm"
        push
        icon="logout"
        glossy
        color="white"
        text-color="accent"
        label="Войти"
        type="submit"
      />
      <q-btn
        push
        size="sm"
        label="Стереть"
        type="reset"
        color="white"
        text-color="standard"
        class="q-ml-sm"
      />
    </div>
  </q-form>

</div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import { useAuthStore } from '~store/auth/authModule';

export default defineComponent({
  setup() {
    const data = reactive({
      login: '',
      password: '',
    });
    const authStore = useAuthStore();
    const isLoading = ref(false);
    const isPwd = ref(true);

    const onSubmit = () => {
      authStore.signIn(data.login, data.password);
    };
    const onReset = () => {
      data.login = '';
      data.password = '';
    };

    return {
      data,
      onSubmit,
      onReset,
      isPwd,
    };
  },
});
</script>
